import { DragDropModule } from "@angular/cdk/drag-drop";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AutocompleteFormControlModule, DateFormControlModule, DynamicFormModule, SelectFormControlModule, SliderFormControlModule, TextFormControlModule } from "core/dynamic-form";

import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { ChecklistFormControlModule, FormControlsUtilsModule, TextAreaFormControlModule } from "core/dynamic-form";
import { PdfModule } from "core/pdf-new";
import { SharedComponentsModule } from "core/shared-components";
import { FixedScrollDirective } from "../../../../../core/shared-components/src/directives/fixed-scroll.directive";
import { DsgTranslatePipe } from "../../pipes/translate.pipe";
import { ApplyClassOnChildDirective } from "../../shared-components/apply-class-on-child.directive";
import { DropListClassDirective } from "./drag/drop-list-class.directive";
import { DropTargetDirective } from "./drag/drop-target.directive";
import { ActorHueService } from "./services/actor-hue.service";
import { SignProcessWizardComponent } from "./sign-process-wizard.component";
import { DocumentCollectionComponent } from "./steps/1-document-upload-step/document-collection/document-collection.component";
import { DocumentItemComponent } from "./steps/1-document-upload-step/document-collection/document-item/document-item.component";
import { FileDragDropComponent } from "./steps/1-document-upload-step/document-collection/file-drag-drop/file-drag-drop.component";
import { FileDragDropDirective } from "./steps/1-document-upload-step/document-collection/file-drag-drop/file-drag-drop.directive";
import { DocumentInfoFormComponent } from "./steps/1-document-upload-step/document-info-form/document-info-form.component";
import { DocumentUploadStepComponent } from "./steps/1-document-upload-step/document-upload-step.component";
import { ActivityCollectionUnorderedComponent } from "./steps/2-select-activities-step/activity-collection-unordered/activity-collection-unordered.component";
import { ActivityItemUnorderedComponent } from "./steps/2-select-activities-step/activity-collection-unordered/activity-item-unordered/activity-item-unordered.component";
import { ActivityCollectionComponent } from "./steps/2-select-activities-step/activity-collection/activity-collection.component";
import { ActivityItemGroupComponent } from "./steps/2-select-activities-step/activity-collection/activity-item-group/activity-item-group.component";
import { ActivityItemComponent } from "./steps/2-select-activities-step/activity-collection/activity-item/activity-item.component";
import { ActorAuthChecklistComponent } from './steps/2-select-activities-step/activity-collection/activity-item/actor-auth.checklist/actor-auth.checklist.component';
import { ActorAuthComponent } from './steps/2-select-activities-step/activity-collection/activity-item/actor-auth/actor-auth.component';
import { ActorConfigComponent } from './steps/2-select-activities-step/activity-collection/activity-item/actor-config/actor-config.component';
import { ActorSplugFormComponent } from "./steps/2-select-activities-step/activity-collection/activity-item/actor-splug-form/actor-splug-form.component";
import { ActorSplugInfoComponent } from "./steps/2-select-activities-step/activity-collection/activity-item/actor-splug-info/actor-splug-info.component";
import { ActorComponent } from './steps/2-select-activities-step/activity-collection/activity-item/actor/actor.component';
import { SelectActivitiesStepComponent } from "./steps/2-select-activities-step/select-activities-step.component";
import { ActorCardCollectionComponent } from "./steps/3-select-tasks-step/actor-card-collection/actor-card-collection.component";
import { ActorCardItemComponent } from "./steps/3-select-tasks-step/actor-card-collection/actor-card-item/actor-card-item.component";
import { ActorSettingsComponent } from "./steps/3-select-tasks-step/actor-card-collection/actor-settings/actor-settings.component";
import { PdfSignaturePdfViewerComponent } from "./steps/3-select-tasks-step/pdf-signature-viewer/pdf-signature-viewer.component";
import { SelectTasksStepComponent } from "./steps/3-select-tasks-step/select-tasks-step.component";
import { AllowedSignatureTypesChecklistComponent } from "./steps/3-select-tasks-step/signature-options/allowed-signature-types-checklist/allowed-signature-types-checklist.component";
import { BatchAutocompleteComponent } from "./steps/3-select-tasks-step/signature-options/batch-autocomplete/batch-autocomplete.component";
import { SignatureOptionsComponent } from "./steps/3-select-tasks-step/signature-options/signature-options.component";
import { ResizeBtnDirective } from "./steps/3-select-tasks-step/signature/directives/resize-btn.directive";
import { SignatureToolbarComponent } from "./steps/3-select-tasks-step/signature/signature-toolbar/signature-toolbar.component";
import { SignatureComponent } from "./steps/3-select-tasks-step/signature/signature.component";
import { ProcessReviewActivityComponent } from './steps/4-review-step/process-review/process-review-activity/process-review-activity.component';
import { ProcessReviewFieldComponent } from "./steps/4-review-step/process-review/process-review-field/process-review-field.component";
import { ProcessReviewComponent } from './steps/4-review-step/process-review/process-review.component';
import { ReviewStepComponent } from "./steps/4-review-step/review-step.component";

@NgModule({
  declarations: [

    SignProcessWizardComponent,

    ActivityCollectionComponent,
    ActivityItemComponent,

    DocumentCollectionComponent,
    DocumentItemComponent,

    DocumentUploadStepComponent,
    SelectActivitiesStepComponent,
    SelectTasksStepComponent,
    ReviewStepComponent,

    FileDragDropComponent,
    FileDragDropDirective,
    DocumentInfoFormComponent,
    ActorSplugInfoComponent,
    ActorSplugFormComponent,
    PdfSignaturePdfViewerComponent,
    ActivityItemGroupComponent,

    SignatureOptionsComponent,
    AllowedSignatureTypesChecklistComponent,
    ActorCardCollectionComponent,
    ActorCardItemComponent,

    SignatureComponent,
    SignatureToolbarComponent,
    BatchAutocompleteComponent,

    ActorComponent,
    ActorAuthComponent,
    ActorAuthChecklistComponent,
    ActorConfigComponent,
    ProcessReviewComponent,
    ProcessReviewFieldComponent,
    ProcessReviewActivityComponent,
    ResizeBtnDirective,
    ActorSettingsComponent,
    ActivityCollectionUnorderedComponent,
    ActivityItemUnorderedComponent,
    DropListClassDirective,
    DropTargetDirective
  ],
  providers: [
    ActorHueService
  ],
  exports: [
    SignProcessWizardComponent,
    ProcessReviewComponent
  ],
  imports: [
    CommonModule,
    ApplyClassOnChildDirective,
    DynamicFormModule,
    MatStepperModule,
    MatButtonModule,
    SharedComponentsModule,
    DsgTranslatePipe,
    MatInputModule,
    DateFormControlModule,
    TextFormControlModule,
    FormControlsUtilsModule,
    SliderFormControlModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatIconModule,
    MatCheckboxModule,
    MatGridListModule,
    AutocompleteFormControlModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    ScrollingModule,
    MatTooltipModule,
    MatAutocompleteModule,
    PdfModule,
    MatMenuModule,
    ChecklistFormControlModule,
    TextAreaFormControlModule,
    MatSelectModule,
    FixedScrollDirective,
    SelectFormControlModule

  ]
})
export class SignProcessWizardModule { }
